import {
  Target,
  TrendingUp,
  Eye,
  Handshake,
  Briefcase,
  Users,
  Award,
} from "lucide-react";

/**
 * DIFERENCIAIS ESTRATÉGICOS
 * Elementos que compõem a seção "Por que nos escolher"
 */
export const differentials = [
  {
    icon: Target,
    title: "Soluções Personalizadas",
    description:
      "Cada empresa é única. Desenvolvemos estratégias sob medida para suas necessidades específicas.",
  },
  {
    icon: TrendingUp,
    title: "Resultados Mensuráveis",
    description:
      "Acompanhamento constante com métricas claras para demonstrar o impacto do nosso trabalho.",
  },
  {
    icon: Eye,
    title: "Transparência Total",
    description:
      "Comunicação aberta e relatórios detalhados em todas as etapas do processo.",
  },
  {
    icon: Handshake,
    title: "Parcerias Duradouras",
    description:
      "Construímos relacionamentos de longo prazo baseados em confiança e resultados.",
  },
];

/**
 * SOLUÇÕES CORPORATIVAS
 * Mapeamento de serviços para a SolutionsSection com foco em conversão
 */
export const solutions = [
  {
    icon: Briefcase,
    title: "Gestão Administrativa",
    description: "Organização completa dos processos internos da sua empresa.",
  },
  {
    icon: Users,
    title: "Consultoria Operacional",
    description: "Otimização de fluxos de trabalho e aumento de produtividade.",
  },
  {
    icon: Award,
    title: "Planejamento Estratégico",
    description:
      "Definição de metas e caminhos para o crescimento sustentável.",
  },
];
